import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const CodeIcon = React.memo(function CodeIcon(props: TCodeIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Code" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.75892 19.1936L12.8044 2.37543L14.2411 2.80645L9.19566 19.6246L7.75892 19.1936ZM1.21966 10.4697L5.70451 5.98483L6.76517 7.04549L2.81065 11L6.76517 14.9545L5.70451 16.0152L1.21966 11.5303L0.689331 11L1.21966 10.4697ZM16.2955 5.98483L20.7803 10.4697L21.3106 11L20.7803 11.5303L16.2955 16.0152L15.2348 14.9545L19.1893 11L15.2348 7.04549L16.2955 5.98483Z"
            />
        </IconBase>
    );
});

export default CodeIcon;

// #region Types

export type TCodeIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <CodeIcon /> : { ...IconBaseExample, render: CodeIcon };

// #endregion
